import React, { useEffect, useState } from 'react';
import NavigationItem from './NavigationItem';
import { useSelector } from 'react-redux';
import useWindowRezise from '../hooks/useWindowRezise';
import { throttle } from 'lodash-es';

const Navigation = () => {
    const [logoSrc, setLogoSrc] = useState(null);

    const { width } = useWindowRezise();

    const [navOffSetTop, setoffSetTop] = useState(null);
    const [facetedSearchOffSetTop, setFacetedSearchoffSetTop] = useState(null);
    const navbar = document.querySelector('.header__main');
    const facetedSearch = document.querySelector('.filtersticky');
    const handleScroll = () => {
        if (width > 767) {
            if (window.scrollY >= navOffSetTop) {
                navbar.classList.add('sticky-nav');
            } else {
                navbar.classList.remove('sticky-nav');
            }
            if (facetedSearch) {
                if (
                    navbar.offsetHeight <=
                        facetedSearch.getBoundingClientRect().top ||
                    window.scrollY >= facetedSearchOffSetTop
                ) {
                    facetedSearch.style.top = 10 + navbar.offsetHeight + 'px';
                } else {
                    facetedSearch.style.top = '';
                }
            }
        }
    };

    useEffect(() => {
        const throttledScroll = throttle(handleScroll, 200);
        if (width > 767) {
            if (navbar && navOffSetTop == null) {
                setoffSetTop(navbar.offsetTop);
            }
            if (facetedSearch && facetedSearchOffSetTop == null) {
                setFacetedSearchoffSetTop(facetedSearch.offsetTop);
            }
            window.addEventListener('scroll', throttledScroll);
        } else {
            if (navbar.classList.contains('sticky-nav')) {
                navbar.classList.remove('sticky-nav');
            }
        }
        return () => {
            window.removeEventListener('scroll', throttledScroll);
        };
    }, [handleScroll]);
    useEffect(() => {
        const logoImg = document.querySelector('.header__logo img');
        if (typeof logoSrc !== 'undefined') setLogoSrc(logoImg.src);
    }, []);
    const contentLinks = useSelector((state) => state.navigation.contentLinks);
    const additionalLinks = useSelector(
        (state) => state.navigation.additionalHeaderLinks
    );

    return (
        <NavigationItem
            logoSrc={logoSrc}
            links={contentLinks}
            additionalHeaderLinks={additionalLinks}
            width={width}
        />
    );
};

export default Navigation;
